var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartup1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 589,
    height: 531,
    viewBox: "0 0 589 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2633_2865)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2633_2865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.24 102.532C439.541 168.427 379.331 262.59 314.594 303.789C239.988 351.259 177.39 316.915 131.618 369.712C89.8373 417.874 120.644 471.114 88.1881 503.885C58.359 534 -17.0514 538.918 -208.873 444.69",
    stroke: "url(#paint0_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-209.033 435.041C-19.7754 527.771 56.4566 524.03 87.6853 494.966C110.807 473.39 104.437 441.926 112.019 409.123C115.602 392.446 123.292 376.909 134.4 363.907C170.762 321.282 216.875 332.901 273.287 313.949C287.69 309.155 301.479 302.696 314.37 294.703C380.008 254.3 442.631 165.862 414.101 101.3",
    stroke: "url(#paint1_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-209.17 425.405C-22.4824 516.626 54.533 514.072 87.081 486.098C111.005 465.533 106.016 434.865 114.292 403.023C118.357 386.547 126.15 371.206 137.077 358.169C172.645 315.751 216.837 324.482 273.032 304.838C287.33 299.871 301.074 293.447 314.046 285.667C380.464 245.857 445.628 163.358 419.867 100.13",
    stroke: "url(#paint2_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-209.303 415.798C-25.2279 505.493 52.5954 504.094 86.5254 477.214C111.259 457.625 107.622 427.802 116.617 396.891C121.145 380.636 129.029 365.492 139.765 352.426C174.581 310.186 216.764 316.103 272.788 295.721C287.004 290.605 300.725 284.218 313.783 276.636C381.047 237.54 448.676 160.865 425.686 98.9717",
    stroke: "url(#paint3_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-209.47 406.138C-27.9459 494.355 50.6296 494.119 85.9729 468.312C111.477 449.71 109.246 420.696 118.97 390.754C123.966 374.71 131.957 359.742 142.525 346.634C176.589 304.573 216.789 307.643 272.669 286.521C286.759 281.244 300.421 274.897 313.535 267.536C381.656 229.146 451.743 158.286 431.533 97.7193",
    stroke: "url(#paint4_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-209.666 396.528C-30.6749 483.226 49.3614 485.135 85.427 459.422C111.19 441.098 110.917 413.665 121.295 384.623C126.764 368.809 134.863 354.018 145.254 340.864C178.566 298.982 216.762 299.22 272.417 277.395C286.409 271.977 300.037 265.67 313.217 258.513C382.222 220.872 454.746 155.794 437.301 96.5513",
    stroke: "url(#paint5_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-209.768 386.856C-33.4001 472.079 46.6493 474.098 84.9052 450.59C111.838 433.855 112.568 406.557 123.624 378.472C129.556 362.901 137.761 348.281 147.977 335.083C180.537 293.379 216.766 290.774 272.208 268.239C286.095 262.669 299.685 256.394 312.927 249.44C382.789 212.506 457.799 153.285 443.103 95.3441",
    stroke: "url(#paint6_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-209.923 377.219C-36.1508 460.964 44.6856 464.152 84.3173 441.638C112.027 425.945 114.301 399.531 125.966 372.345C132.355 357.029 140.675 342.58 150.726 329.345C182.516 287.816 216.765 282.348 272.026 259.128C284.875 253.711 298.445 247.705 312.671 240.421C383.421 204.218 460.83 150.745 448.919 94.1594",
    stroke: "url(#paint7_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210.078 367.581C-38.8557 449.803 42.6465 454.091 83.7741 432.775C112.21 418.023 116.038 392.486 128.335 366.213C135.187 351.157 143.62 336.862 153.493 323.565C184.532 282.214 216.8 273.928 271.854 249.963C284.674 244.388 298.198 238.382 312.437 231.343C383.973 195.923 463.869 148.216 454.735 92.9743",
    stroke: "url(#paint8_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210.215 357.947C-41.5753 438.666 40.6206 444.05 83.2065 423.852C112.352 410.038 117.814 385.385 130.632 360.083C137.932 345.302 146.474 331.157 156.166 317.801C186.463 276.622 216.748 265.489 271.634 240.86C284.371 235.16 297.906 229.147 312.149 222.343C384.664 187.654 466.949 145.747 460.579 91.8296",
    stroke: "url(#paint9_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210.371 348.31C-44.3058 427.537 38.5805 433.989 82.6276 414.982C112.475 402.095 119.543 378.375 132.938 353.948C140.696 339.457 149.357 325.461 158.872 312.044C188.408 271.051 216.717 257.083 271.375 231.678C284.069 225.798 297.579 219.816 311.81 213.243C385.23 179.334 469.921 143.186 466.343 90.5887",
    stroke: "url(#paint10_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210.527 338.673C-47.0333 416.39 36.5607 423.915 82.1006 406.078C112.653 394.101 121.351 371.328 135.282 347.802C143.293 334.283 151.553 320.527 161.621 306.261C190.411 265.457 216.73 248.632 271.193 222.521C283.828 216.485 297.325 210.527 311.576 204.165C385.9 171.036 473.009 140.64 472.184 89.3726",
    stroke: "url(#paint11_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210.683 329.036C-49.7812 405.213 34.454 413.868 81.5354 397.185C112.801 386.127 123.174 364.301 137.616 341.664C146.137 328.303 154.539 314.694 164.349 300.491C192.367 259.835 216.719 240.212 270.99 213.378C283.561 207.176 297.054 201.235 311.278 195.129C386.512 162.807 476.033 138.135 477.972 88.1913",
    stroke: "url(#paint12_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210.861 319.414C-52.4935 394.116 32.4537 403.736 80.9682 388.291C112.926 378.123 125.001 357.285 139.941 335.515C148.996 322.327 157.522 308.86 167.026 294.739C194.324 254.285 216.651 231.8 270.772 204.215C283.302 197.86 296.771 191.95 310.987 186.058C387.153 154.558 479.078 135.616 483.781 86.9962",
    stroke: "url(#paint13_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210.98 309.767C-55.2152 382.98 30.367 393.63 80.4191 379.401C113.086 370.125 126.861 350.293 142.27 329.393C151.867 316.389 160.524 303.029 169.802 288.952C196.327 248.691 216.7 223.356 270.576 195.082C283.649 188.392 297.058 182.371 310.748 177.043C387.792 146.325 482.141 133.056 489.597 85.811",
    stroke: "url(#paint14_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-211.137 300.133C-57.9443 371.836 28.3842 383.503 79.8275 370.54C113.197 362.146 128.695 343.334 144.613 323.25C154.757 310.439 163.525 297.201 172.528 283.184C198.313 243.095 216.692 214.922 270.352 185.955C283.311 179.114 296.698 173.109 310.43 167.978C388.472 138.158 485.155 130.559 495.445 84.6527",
    stroke: "url(#paint15_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-211.296 290.499C-60.6788 360.709 26.3516 373.302 79.3076 361.631C113.344 354.112 130.604 336.354 146.94 317.129C157.639 304.522 166.497 291.375 175.242 277.422C200.265 237.519 216.679 206.503 270.168 176.8C283.021 169.822 296.396 163.843 310.174 158.915C389.092 129.923 488.192 128.031 501.225 83.4167",
    stroke: "url(#paint16_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-211.461 280.872C-63.4559 349.533 24.2368 363.196 78.7211 352.747C113.493 346.089 132.48 329.424 149.246 311.008C160.556 298.598 169.473 285.563 177.955 271.664C202.244 231.961 216.653 198.087 269.953 167.66C282.704 160.554 296.069 154.599 309.887 149.869C389.741 121.743 491.237 125.524 507.038 82.2347",
    stroke: "url(#paint17_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-211.636 271.252C-66.2237 338.487 22.1712 353.03 78.1245 343.826C113.596 338.023 134.324 322.471 151.52 304.818C163.348 292.623 172.422 279.664 180.627 265.844C204.153 226.3 216.597 189.602 269.718 158.491C282.365 151.255 295.722 145.325 309.58 140.792C390.376 113.543 494.286 122.911 512.822 81.0114",
    stroke: "url(#paint18_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-211.814 261.632C-68.9322 327.327 20.1156 342.858 77.5651 334.986C113.764 330.033 136.237 315.622 153.877 298.753C166.315 286.845 175.422 273.912 183.367 260.128C206.134 220.771 216.605 181.239 269.524 149.384C282.064 142.014 295.416 136.106 309.314 131.778C391.062 105.443 497.319 120.501 518.661 79.8709",
    stroke: "url(#paint19_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-211.973 252.019C-71.6746 316.208 18.027 332.636 76.9549 326.138C113.857 322.022 138.077 308.779 156.14 292.663C169.183 281.032 178.356 268.13 186.048 254.438C208.07 215.244 216.562 172.867 269.288 140.306C281.731 132.812 295.082 126.924 309.018 122.787C391.721 97.4843 500.315 118.014 524.458 78.7147",
    stroke: "url(#paint20_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-212.161 242.408C11.3528 344.159 110.312 326.618 158.498 286.511C211.101 242.731 198.22 176.074 269.116 131.143C352.29 78.447 498.84 121.916 530.29 77.5205",
    stroke: "url(#paint21_linear_2633_2865)",
    strokeWidth: 1.9,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2633_2865",
    x1: 203.08,
    y1: 430.255,
    x2: 86.4232,
    y2: 251.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2633_2865",
    x1: 203.099,
    y1: 420.525,
    x2: 86.4253,
    y2: 241.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2633_2865",
    x1: 203.11,
    y1: 410.874,
    x2: 86.3995,
    y2: 232.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2633_2865",
    x1: 203.178,
    y1: 401.287,
    x2: 86.398,
    y2: 222.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2633_2865",
    x1: 203.315,
    y1: 391.736,
    x2: 86.3941,
    y2: 212.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2633_2865",
    x1: 203.463,
    y1: 382.353,
    x2: 86.3365,
    y2: 203.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2633_2865",
    x1: 203.715,
    y1: 372.975,
    x2: 86.3476,
    y2: 193.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2633_2865",
    x1: 203.947,
    y1: 363.63,
    x2: 86.3316,
    y2: 183.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2633_2865",
    x1: 204.289,
    y1: 354.448,
    x2: 86.3173,
    y2: 173.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2633_2865",
    x1: 204.662,
    y1: 345.302,
    x2: 86.3149,
    y2: 164.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2633_2865",
    x1: 205.111,
    y1: 336.295,
    x2: 86.2958,
    y2: 154.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2633_2865",
    x1: 205.653,
    y1: 327.385,
    x2: 86.298,
    y2: 144.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2633_2865",
    x1: 206.25,
    y1: 318.615,
    x2: 86.2753,
    y2: 135.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2633_2865",
    x1: 206.932,
    y1: 309.976,
    x2: 86.2518,
    y2: 125.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2633_2865",
    x1: 207.761,
    y1: 301.501,
    x2: 86.2635,
    y2: 115.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2633_2865",
    x1: 208.699,
    y1: 293.217,
    x2: 86.2588,
    y2: 105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2633_2865",
    x1: 209.767,
    y1: 285.142,
    x2: 86.2489,
    y2: 96.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2633_2865",
    x1: 214.211,
    y1: 282.2,
    x2: 86.2692,
    y2: 86.3623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2633_2865",
    x1: 412.166,
    y1: 339.384,
    x2: -201.506,
    y2: 326.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#57AEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825103,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2633_2865",
    x1: 223.9,
    y1: 277.554,
    x2: 86.3052,
    y2: 66.9036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2633_2865",
    x1: 228.948,
    y1: 275.552,
    x2: 86.3265,
    y2: 57.1884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2633_2865",
    x1: 234.108,
    y1: 273.701,
    x2: 86.3515,
    y2: 47.4546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B6D87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#729FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#26CAFB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2633_2865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 531,
    fill: "white",
    transform: "translate(-131)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2633_2865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 861.048,
    height: 462.833,
    fill: "white",
    transform: "matrix(0.883112 -0.470427 -0.618524 -0.785863 -91.3901 622.675)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup1);
export default __webpack_public_path__ + "static/media/startup1.7a97fcc89cee3dd25771c28773d7c7df.svg";
export { ForwardRef as ReactComponent };